<div class="main-container">

    <div class="content">

        <div class="tab-wrapper">
            <app-vertical-tabs
            [selectedTabId]="selectedTab"
            [tabs]="tabList"
            (tabSelected)="selectTab($event)"
            ></app-vertical-tabs>
        </div>

        <div class="scrollable-section">

            <div [hidden]="selectedTab !== 'contactSection'">
                <app-contact-information [contactFormConfig]="contactFormConfig" [contactInformation]="contactInformation" [action]="action" (onValueChange)="onValueChange.emit($event)"></app-contact-information>
            </div>
        
            <div [hidden]="selectedTab !== 'tdsSection'">
                <app-finance-compliance [action]="action" [contactInformation]="contactInformation"></app-finance-compliance>
            </div>
        
            <div class="account-section" [hidden]="selectedTab !== 'accountSection'">
                <div class="header-top contact-header">
                    <div class="header-left">
                    <span class="section-title">Bank Accounts</span>
                    </div>
            
                    <div class="header-right" *ngIf="action !== 'view' && bankAccountList.length > 0">
                    <button type="button" class="tertiary_button" (click)="addAccount()">
                        <app-svg-icon [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
                        Add New Account</button>
                    </div>
                </div>
        
                @if(bankAccountList.length > 0) {
                <div class="account-list">
                    <div class="account-item" *ngFor="let account of bankAccountList; let i = index">
                    <app-item-card
                    [title]="account.accountName"
                    [lines]="getFormattedBankSummary(i)"
                    [badges]="getBankAccountBadges(i)"
                    [actions]="[
                        action === 'view' ? { icon: '/assets/icons/view_icon.svg', name: 'view', class: 'view' }
                         : { icon: '/assets/icons/pencil_icon.svg', name: 'edit', class: 'edit' },
                    ]"
                    (actionClicked)="handleBankAccountAction(i, $event)"
                    ></app-item-card>
                    </div>
                </div>
                } @else {
                <div class="empty-state-container">
                    <app-no-data [msg]="'No bank accounts added yet'" [path]="'assets/icons/empty_bank_accounts_icon.svg'"></app-no-data>
                    <button type="button" class="tertiary_button" *ngIf="!readOnlyMode" (click)="addAccount()">
                        <app-svg-icon [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
                        Add New Account</button>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="footer_actions">
        @if (action !== 'view') {
            <button type="button" class="secondary_button" (click)="close()">
                Close
            </button>

            <ng-container *ngIf="!isLastTab">
                <button type="button" class="primary_button" (click)="goToNextTab()">
                  Next
                </button>
            </ng-container>

            <ng-container *ngIf="isLastTab">
                <button type="button" class="primary_button" (click)="submit()">
                    @if (action === 'edit') {
                        Update Contact
                    } @else if (action === 'add' || action === 'clone') {
                        Add Contact
                    }
                </button>
            </ng-container>
        }
    </div>
</div>
